(function () {
	angular
		.module('trackeye')
		.controller('SubscriptionController', SubscriptionController);

	SubscriptionController.$inject = ["$scope", "$state", "ModalService", "DeviceService", "AccountService", "UserService", "C4ApiService", "NotificationService", "$window", "$location", "$filter"];

	function SubscriptionController($scope, $state, ModalService, DeviceService, AccountService, UserService, api, NotificationService, $window, $location, $filter) {
		var vm = this;

		vm.account = AccountService.get();
		vm.accountConfig = vm.account.getConfiguration();
		vm.devices = DeviceService.getPrepaidDevices();

		vm.transactions = UserService.getTransactions();
		vm.formattedAmount = "0.00";
		
		vm.is_loading = false;

		vm.depositForm = {};

		var depositModal = ModalService.create('deposit', vm),
			depositSuccessModal = ModalService.create('deposit-success'),
			depositCancelledModal = ModalService.create('deposit-cancelled'),
			renewSubscriptionModal = ModalService.create('renew-subscription');

		var payment = $location.search();

		vm.openDepositModal = function() {
			depositModal.open();
		};

		if (angular.isDefined(payment.payment)) {
			if (payment.payment == "true") {
				depositSuccessModal.open(payment);
				$state.go('dashboard.main.pages.modal', {modal: 'payment-success', eventData: payment});
			} else if (payment.payment == "false") {
				depositCancelledModal.open(payment);
				$state.go('dashboard.main.pages.modal', {modal: 'payment-cancelled', eventData: payment});
			}
		}

		$scope.$on('DeviceService.initialized', function () {
			vm.devices = DeviceService.getPrepaidDevices();
		});

		vm.getInvoice = function (uuid) {
			if (uuid) {
				$window.open('/api/invoice?uuid=' + uuid);
			}
		};

		vm.renewSubscription = function (device) {
			renewSubscriptionModal.open({
				device: device,
				subCtrl: vm
			});
			//$state.go("renew-subscription", {nodeid: device.nodeid});
		};

		vm.makeDeposit = function () {
			if (!hasBillingData(vm.account)) {
				NotificationService.warning('STR_ACCOUNT_INFORMATION_MISSING');
				return;
			}

			if (vm.depositForm.amount.$error.pattern || !vm.formattedAmount) {
				return;
			}

			var amount = vm.formattedAmount.replace(/(\.|\,)/,'.');

			vm.is_loading = true;

			if (amount) {
				var personal = vm.accountConfig.data.personal,
					settings = vm.accountConfig.data.settings;

				amount = parseFloat(amount) * 100;

				api.payment_link({
					account_id: vm.account.id,
					amount: amount,
					currency: vm.account.currency,
					cust_name: vm.account.name,
					cust_address: personal.street,
					cust_zipcity: personal.zip + " " + personal.town,
					cust_lang: settings.locale
				}).then(function (response) {
					$window.location.href = response.data.link;
				}, function (data) {
					console.warn(data);
				});
			} else {
				vm.is_loading = false;
				vm.depositForm.$setValidity('required', false);
			}
		};

		/**
		 * Asserts if the account, has all the needed billing data.
		 * @param {Account} account
		 * @returns {boolean}
		 */
		function hasBillingData(account) {
			return (
				account.getName() &&
				account.getStreet() &&
				account.getTown() &&
				account.getZip()
			);
		}

		vm.suggestDepositAmount = function (plan, options) {
			if (plan) {
				var vatDecimal = (options.vatcode / 10000) + 1,
					price = plan.price * vatDecimal,
					balance = vm.account.balance;

				vm.formattedAmount = $filter('number')( ((price - balance) / 100), 2);
			}
		}
	}
})();